// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"5ce9991a","453":"5d1e1a24","501":"4bfad4a8","925":"541f764b"}[chunkId] + ".chunk.js";
};